export default {
  props:{
    // Id:{
    //   type: String,
    // },
    // row:{
    //   type:Object,
    //   default: () => {}
    // }

  },
  data() {
    let isNum = (rule, value, callback) => {
      var reg2 = /^[0-9]+([.]{1}[0-9]{1,2})?$/;
      if(value == 0){
        callback(new Error('请输入大于0的数字'))
      }
      if (!reg2.test(value)) {
        callback(new Error('请输入数字'))
      }else{
        callback()
      }
    };
    return {
      count:0,
      limit:1,
      hideUpload: false,
      fileList:[],
      mesRight:'',
      MyPriceListError:[
        {
          CreateTime:'2022-06-13 10:20:03',
          AutionPrice:'4500',
          FirstQuantity:'500',
          AutionQuantity:'300'
        },
        {
          CreateTime:'2022-06-13 12:20:03',
          AutionPrice:'6000',
          FirstQuantity:'300',
          AutionQuantity:'300'
        }
      ],
      CompanyIdPrinter:'',
      pinInfo:{
        SalerCompanyName:'神驰化工集团有限公司',
        LinkTel:'0546-8656959',
        Address:'山东省东营市东营区郝纯路129号',
        CompanyName:'北京诺伊斯特',
        CompanyAddr:'潍坊市软件园',
        CompanyTel:'0539-2306119',
        CompanyLinkUser:'Mr Song',
        list:[
          {
            ProductName:'产品1',
            Unit:'吨',
            AutionQuantity:'100',
            SucessPrice:'200',
            Amount:'22222'
          }
        ]
      },
      fullscreenLoading:false,
      printMeObj: {
        id: 'printNotes',
        popTitle: '竞采通知单',
      },
      printerDialog:false,
      activeNameZb:'second',
      IsStandard:null,
      Id:'',
      tableLoading:false,
      tableLoadingDetail:false,
      MyPriceList:[],
      priceDetail:[],
      companyArr:[],
      priceNum:'',
      activeBottom:'second',
      formRow:{},
      status:'',
      BidRow:{},
      centerDialogVisible:false,
      centerDialogVisible1:false,
      outPriceFlag:false,
      refreshPriceFlag:false,
      formBid:{
        AuctionNum:0,
        AddPrice:0,
        AuctionPrice:0,//计算出的含税金额
        CurrentMinPrice:0,
        CurrentMaxPrice:0,
        CompanyId:'',
        AuctionId:'',
        ShowPriceIndex:'',
        IsShowPriceIndex:null,
        Remark:'',
        PriceItems:[],
        AttachUrl:'',
        ShipDate:''
      },
      formJoin:{
        AuctionId:'',
        CompanyId:'',
      },
      loadingScreen:null,
      url:{
        get:SZH.assets.api + '/AuctionPurchase2/GetAuctionDetailInfoForWeb',
        GetMyPriceList:SZH.assets.api + '/AuctionPurchase2/GetMyPriceList',
        GetCurrentAuction:SZH.assets.api + '/AuctionPurchase2/GetCurrentAuction',
        GetMyPriceNoticeItem:SZH.assets.api + '/AuctionPurchase2/GetMyPriceNoticeItem',
        GetCurrentAuctionDetail:SZH.assets.api + '/AuctionPurchase2/GetCurrentAuctionDetail',
        GetCompanyItem:SZH.assets.api + '/AuctionPurchase2/GetCompanyItem',
        OfferPriceRequest:SZH.assets.api + '/AuctionPurchase2/OfferPriceRequest',
        creatOrder:SZH.assets.api + '/AuctionPurchase2/ToPayToCreateOrder',
        JoinInAuction:SZH.assets.api + '/AuctionPurchase2/JoinInAuction',
        cuttent:SZH.assets.api + '/AuctionPurchase2/GetCurrentDateTime',
        GetActionPrintForm:SZH.assets.api + '/AuctionPurchase2/GetActionPrintForm',
        GetProcessItems:SZH.assets.api + '/AuctionPurchase2/GetProcessItems',
      },
      rules:{
        AuctionNum: [
          {
            required: true,
            message: '请输入数字',
            trigger: 'blur'
          },
          {
            validator: isNum,
            trigger: 'blur'
          }
        ],
        AuctionPrice: [
          {
            required: true,
            message: '请输入数字',
            trigger: 'blur'
          },
          {
            validator: isNum,
            trigger: 'blur'
          }
        ],
        CompanyId: [
          {
            required: true,
            message: '请选择企业',
            trigger: 'blur'
          },
        ],
      },
      timeInterval:null,
      timeStr:'',
      currentFWQTime:'',
      AllNum:0,
      biddingProcessDetail:false,
      tableData:[]
    }
  },
  methods: {
    downloadFJ(url){
      window.open(url);
    },
    beforeUpload(file){
      const _self = this;
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isLt2M) {
        _self.$message.error('上传的文件大小不能超过 30MB!');
      }
      return isLt2M;
    },
    handleRemove(file, fileList) {
      var self = this;
      self.count = fileList.length;
      this.fileList = [];
    },
    handleSuccess(response, file, fileList) {
      if (response && response[0].success == true) {
        this.count = fileList.length;
        this.fileList = [];
        this.formBid.AttachUrl = response[0].FileName;
        let obj = {
          name:'',
          url:''
        };
        obj.name = response[0].File;
        obj.url = response[0].FileName;
        this.fileList.push(obj);
        // this.$emit("input", this.photos);
      }else{
        this.$message.error(response[0].message)
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制只能选择 1 个文件`);
    },
    returnStep(max){
      return max*this.BidRow.AddPrice
    },
    onKeydown(event) {
      if (event.key !== "ArrowUp" && event.key !== "ArrowDown") {
        event.preventDefault();
      }
    },
    cellStyleFun({row, column, rowIndex, columnIndex}) {
      if(column.property == 'AutionQuantity'){
        return {color: 'red',fontWeight:600}
      }
    },
    //打印
    onPrinter(){
      let self = this;
      self.printerDialog = true;
      self.fullscreenLoading = true;
      self.$http.post(self.url.GetActionPrintForm,{
        Data:{
          CompanyId:self.CompanyIdPrinter,
          AuctionId:self.Id
        }
      }).then(result =>{
        if(result.state == true){
          self.pinInfo.SalerCompanyName = result.data.SalerCompanyName;
          self.pinInfo.LinkTel = result.data.LinkTel;
          self.pinInfo.Address = result.data.Address;
          self.pinInfo.CompanyName = result.data.company.CompanyName;
          self.pinInfo.CompanyAddr = result.data.company.CompanyAddr;
          self.pinInfo.CompanyTel = result.data.company.CompanyTel;
          self.pinInfo.CompanyLinkUser = result.data.company.CompanyLinkUser;
          self.pinInfo.list = result.data.list;
        }else{
          self.pinInfo.SalerCompanyName = '';
          self.pinInfo.LinkTel = '';
          self.pinInfo.Address = '';
          self.pinInfo.CompanyName = '';
          self.pinInfo.CompanyAddr = '';
          self.pinInfo.CompanyTel = '';
          self.pinInfo.CompanyLinkUser = '';
          self.pinInfo.list = [];
        }
        self.fullscreenLoading = false;
      }, () => {
        self.fullscreenLoading = false;
        self.$message.error('获取数据失败，请检查您的网络是否可用。');
      });
    },
    getMsg(id){
      let self = this;
      self.$http.post(self.url.get,{
        Data:id
      }).then(result =>{
        if(result.state == true){

          self.formRow = result.data;
          self.status = result.data.Status;
          self.IsStandard = result.data.IsStandard;
          // self.formJoin.CompanyId = result.data.CompanyId;
          self.CompanyIdPrinter = result.data.CompanyId;
        }else{
        }
      }, () => {
        self.$message.error('获取数据失败，请检查您的网络是否可用。');
      });
    },
    getMyList(){
      let self = this;
      self.tableLoading = true;
      self.AllNum = 0;
      self.$http.post(self.url.GetMyPriceList,{
        Data:self.Id
      }).then(result =>{
        if(result.state == true && result.data.length>0){
          self.tableLoading = false;
          self.MyPriceList = result.data;
          result.data.forEach(item=>{
            self.AllNum = self.AllNum + item.AutionQuantity
          });
          self.priceNum = self.MyPriceList.length;
        }else{
          self.tableLoading = false;
          self.MyPriceList = []
        }
      }, () => {
        self.tableLoading = false;
        self.$message.error('获取数据失败，请检查您的网络是否可用。');
      });
    },
    getDetail(id){//点击明细获取出价明细
      let self = this;
      self.biddingProcessDetail = true;
      self.$http.post(self.url.GetProcessItems,{
        Data:id
      }).then(result =>{
        if(result.state == true && result.data.length>0){
          self.tableData = result.data;
        }else{
          self.tableData = []
        }
      }, () => {
        self.$message.error('获取数据失败，请检查您的网络是否可用。');
      });
    },
    handleClick(name){
      if(name == 'first'){
        this.getMyList();
      }else if(name == 'second'){
        // this.getCurrentList();
      }
    },
    handleClickCh(){},
    getCompany(){
      let self = this;
      self.$http.post(self.url.GetCompanyItem,{
      }).then(result =>{
        if(result.state == true && result.data.length>0){
          self.companyArr = result.data;
          self.formJoin.CompanyId = result.data[0].value;
        }else{
          self.companyArr = [];
        }
      }, () => {
        self.$message.error('数据保存失败，请检查您的网络是否可用。');
      });
    },
    toBid(){
      let self = this;
      if(self.status){
        if(self.formRow.State == 2){
          self.centerDialogVisible = true;
          self.formBid.AuctionNum = 0;
          self.formBid.AuctionPrice = 0;
          self.formBid.ShipDate = '';
          self.fileList = [];
          self.refreshData();
        }else{
          self.$message.error('当前竞采未开始，请开始后再进行出价。');
        }

      }else{
        // self.centerDialogVisible1= true;
        self.toJoin()
      }

    },
    toJoin(){
      let self = this;
      self.formJoin.AuctionId = self.Id;
      self.outPriceFlag = true;
      self.$http.post(self.url.JoinInAuction, {Data:self.formJoin }).then(result => {
        if (result.state == true) {
          self.outPriceFlag = false;
          self.centerDialogVisible1= false;
          self.$message.success('参与成功');
          self.getMsg(self.Id);
        } else {
          self.outPriceFlag = false;
          // self.centerDialogVisible1= false;
          self.$message.error(result.message);
        }
      }, () => {
      });
    },
    comMoney(row){
      let self = this;
      row.F_Amount = (row.F_Price*row.F_Quantity).toFixed(2);
      let autionPrice = 0;
      let itemsFlag = [];
      itemsFlag = self.formBid.PriceItems.filter(item=>item.F_Price>0);
      self.formBid.PriceItems.forEach(item=>{
        autionPrice = autionPrice+item.F_Amount*1;
      });
      self.formBid.AuctionPrice = autionPrice;
    },
    outPrice(){
      let self = this;
      self.formBid.AuctionId = self.Id;
      self.formBid.CompanyId = self.formJoin.CompanyId;
      if(!self.formBid.ShipDate){
        self.$message.error('请输入交货期！');
        return
      }
      let itemsFlag = [];
      itemsFlag = self.formBid.PriceItems.filter(item=>item.F_Price>0 && item.F_TaxFee);
      if(itemsFlag && itemsFlag.length == self.formBid.PriceItems.length){
        // //含税金额和不含税金额计算
        // //TODO 这里的数据如果是小数可能会出现问题，后期留意
        // let autionPrice = 0;
        // self.formBid.PriceItems.forEach(item=>{
        //   item.F_Amount = item.F_Price*item.F_Quantity;
        //   // item.F_NoTaxAmount = item.F_Amount-item.F_Amount*item.F_TaxFee;
        //   autionPrice = autionPrice+item.F_Amount*1;
        // });
        // self.formBid.AuctionPrice = autionPrice;

        self.$confirm('确认出价吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.outPriceLast();
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消出价'
          });
        });
      }else{
        self.$message.error('请输入价格税费！');
      }

    },

    outPriceLast(){
      let self = this;
      self.outPriceFlag = true;
      self.$http.post(self.url.OfferPriceRequest, {Data:self.formBid }).then(result => {
        if (result.state == true) {
          self.outPriceFlag = false;
          self.centerDialogVisible = false;
          self.$message.success('出价成功');
          self.reLoad();
        } else {
          self.outPriceFlag = false;
          // self.centerDialogVisible = false;
          self.$message.error(result.message);
        }
      }, () => {
      });
    },
    reLoad(){
      this.getMyList();
      this.getMsg(this.Id);
      this.refreshData();
    },
    refreshData(v){
      let self = this;
      self.getcuttent();
      // self.refreshPriceFlag = true;
      self.$http.post(self.url.GetCurrentAuctionDetail,{
        Data:self.Id
      }).then(result =>{
        if(result.state == 1){
          self.refreshPriceFlag = false;
          self.BidRow = result.data;
          self.formBid.CurrentMaxPrice = result.data.MyMinPrice;
          // self.formBid.AuctionPrice = result.data.CurrentMaxPrice;
          self.formBid.CurrentMinPrice = result.data.CurrentMinPrice;//最低价
          self.formBid.AuctionNum = result.data.StartWeight;
          self.formBid.AddPrice = result.data.AddPrice;
          self.formBid.IsShowPriceIndex = result.data.IsShowPriceIndex;
          self.formBid.ShowPriceIndex = result.data.ShowPriceIndex;
          self.formBid.PriceItems = result.data.Items;
          if(result.data.AutionModel == 0){//询比价这种需要将F_Price值为0
            result.data.Items.forEach(item=>{
              item.F_Price = 0
            });
          }
          var time = 0;
          if(result.data.State == 1){
            time = new Date(result.data.AutionStartTime).getTime() - new Date(self.currentFWQTime).getTime()
          }else if(result.data.State == 2){
            // time = result.Data.TaskType == 1? new Date(result.Data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime():new Date(result.Data.DynamicEndTime).getTime() - new Date(self.currentFWQTime).getTime();
            time = result.data.TaskType == 1? new Date(result.data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime():new Date(result.data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime();
          }
          // var time = result.Data.TaskType == 1? new Date(result.Data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime():new Date(result.Data.DynamicEndTime).getTime() - new Date(self.currentFWQTime).getTime();;
          if(result.data.State == 3){
            self.timeStr = '已结束';
            return
          }
          //如果时间进来就是负数直接return
          if(time<0){
            self.timeStr = '已结束';
            return;
          }
          self.formatDuring(time);
          // self.timeStr = '0 秒';
          if(self.timeInterval){
            clearInterval(self.timeInterval);
            self.timeInterval = setInterval(()=>{
              time = time-1000;
              if(time>-1000){
                self.formatDuring(time)
              }else{
                //未开始的时候倒计时结束刷新页面进行状态更新成为一开始

                self.timeStr = '已结束';
                if(!v){
                  self.getMsg(self.Id);
                  self.refreshData(true);
                }

                if(result.data.State == 1){

                }else if(result.data.State == 2){
                  self.centerDialogVisible = false;
                  location.reload();
                }
                clearInterval(self.timeInterval);
              }
            },1000)
          }else{
            self.timeInterval = setInterval(()=>{
              time = time-1000;
              if(time>-1000){
                self.formatDuring(time);
              }else{
                self.timeStr = '已结束';
                if(!v){
                  self.getMsg(self.Id);
                  self.refreshData(true);
                }
                // self.refreshData(true);
                if(result.data.State == 1){

                }else if(result.data.State == 2){
                  self.centerDialogVisible = false;
                  location.reload();
                }
                clearInterval(self.timeInterval);
                // self.dialogVisible = true;
              }
            },1000)
          }


        }else{
          self.refreshPriceFlag = false;
          // self.$message.error(result.Message);
        }
      }, () => {
        self.$message.error('数据获取失败，请检查您的网络是否可用。');
      });
    },
    formatDuring(mss) {
      var days = parseInt(mss / (1000 * 60 * 60 * 24));
      var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (mss % (1000 * 60)) / 1000;
      this.timeStr = days + " 天 " + hours+" 小时"+ minutes + " 分钟 " + Math.ceil(seconds) + " 秒 ";
      //return days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
    },
    creatOrder(row){

      let self = this;
      self.loadingScreen = this.$loading({
        text: '订单信息提交中, 请勿刷新页面...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.75)'
      });
      let params = {
        ProcessId:row.ProcessId,
        SalesUser:'',
        CustomNo:''
      }
      self.$http.post(self.url.creatOrder,{
        Data:params
      }).then(result =>{
        if(result.state == true){
          self.loadingScreen.close();
          var param = {
            type:self.IsStandard
          };
          param.id = [result.Data];
          sessionStorage.setItem('params',JSON.stringify(param))
          self.$router.push({
            path: '/PayOrder',
            name: 'PayOrder',
          })
        }else{
          self.$message.error(result.Message);
          self.loadingScreen.close();
        }
      }, () => {
        // self.tableLoading = false;
        self.loadingScreen.close();
        self.$message.error('获取数据失败，请检查您的网络是否可用。');
      });
    },
    getcuttent(){
      let self = this;
      self.$http.post(self.url.cuttent,{

      }).then(result =>{
        if(result.state == 1 && result.data){
          self.currentFWQTime = result.data;
        }else{
        }
      }, () => {
        self.$message.error('数据保存失败，请检查您的网络是否可用。');
      });
    },

    connectServer() {
      var $this = this;
      // var conn = $.hubConnection(SZH.assets.ws, {qs:`scanKey=${this.uuid}`});
      var conn = $.hubConnection(SZH.assets.ws, {});
      $this.proxy = conn.createHubProxy("NoticeHub");
      $this.toGetMEs();
      conn.start().done((connection) => {
        // $this.sendMsg();
        $this.ClientId = connection.id;
      }).fail((data) => {
      });
    },
    toGetMEs() {
      var $this = this;
      $this.proxy.on("receiveNotice", (data) => {
        $this.mesRight = data;
        if(data){
          // $this.getMyList();
          $this.reLoad();
        }
      });

    },
  },
  destroyed(){
    clearInterval(this.timeInterval);
  },
  computed: {
    ProductImg(){
      return SZH.assets.image + this.formRow.ProductImg
    },
    uploadHeaders() {
      var token = localStorage.ms_token;
      return {Authorization: 'Bearer ' + token};
    },
    uploadUrl() {
      return SZH.assets.api + '/File/PostFile'
    },
    extraParams(){
      return {
        upLoadType:'2',
        upLoadFolder:'',
        ImageType:'fujian',
        code:''
      }
    }
  },
  components: {},
  mounted() {
    this.Id = this.$route.query.id;
    this.getMsg(this.$route.query.id);
    this.connectServer();
    this.getMyList();
    this.getCompany();
    this.refreshData();
    this.getcuttent();
    // this.getCurrentList();
    if (document.hidden !== undefined) {
      document.addEventListener('visibilitychange', () => {
        if(document.hidden == true){
        }else{
          this.refreshData();
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/EnquiryModule/EnquiryDetail/EnquiryDetail.js